var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module__iframe_scorm"},[(_vm.scormUrl && _vm.scormId)?[_c('iframe',{attrs:{"src":_vm.outputScormUrl + '/preview.html?id=' + _vm.scormId}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }